import { render, staticRenderFns } from "./PostButtonMod.vue?vue&type=template&id=52cd2c72"
import script from "./PostButtonMod.vue?vue&type=script&lang=js"
export * from "./PostButtonMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports